import React, { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid } from "@material-ui/core";
import {
  BusinessAdministrationAddressView,
  BusinessAdministrationCertifiesSATView,
  BusinessAdministrationDisableView,
  BusinessAdministrationDetailView,
  BusinessAdministrationCategoriesView
} from "../../views";
// import "./business-administration-panel.css";
import { businessIconDefault } from "../../../assets/logos/icons";
import { ClientCompanyService } from "../../../services";
import moment from "moment";
import "moment/locale/es";

const BusinessAdministrationConfigurationsView = ({
  selectedUser,
  hideShowDetails,
  nameComponentUser,
  optionsTypeBusiness,
  optionsBusinessTurnover,
  setHeaderTitleinDetail,
  token,
  validators,
  forceRefresh,
  toggleCompleted,
  onChangeImgProfile,
  setShowDetails,
  setNameComponentUser,
  showLoadingRequesting,
  showCompletedRequesting,
  showErrorRequesting,
  showWarningRequesting,
  userInformation,
  toggleCompletedRequesting,
  toggleLoadingRequesting,
  toggleErrorRequesting,
  toggleWarningRequesting,
  message,
  setDataUser,
  clientCompany,
  imageProfile,
  procedureManager,
  registryTypes,
  pathView,
  t
}) => {
  const [stateNameComponentUser, setStateNameComponentUser] = useState("");
  const [showGettingData, setShowGettingData] = useState(false);
  const [showDetailComponent, setShowComponentDetail] = useState(false);
  const [imgProfileSubtitle, setImgProfileSubtitle] = useState("");
  // selectedUser.imgProfile || profileIconDefault || ""
  const [valueImgProfile, setValueImgProfile] = useState();

  const [dataImgProfile, setDataImgProfile] = useState();
  const toggleShowDetailComponent = () => {
    setShowComponentDetail(false);
    setStateNameComponentUser(t("businessAdministrationPanelView.grid.actions.view.detail"));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Funtion to open file
  const uploadFileCustom = (ref) => {
    ref.current.click();
  };
  //Function to change image
  // const changeImgFile = (e, imageProfileRef) => {
  //   console.log("echangeree", e);
  //   let fileIn = document.getElementById("fileUploadImgProfile");
  //   let fileOut = document.getElementById("imgProfile");

  //   console.log("fileIn", fileIn);
  //   console.log("fileOut", fileOut);

  //   if (e.target.files && e.target.files[0]) {
  //     console.log(" e.target.files[0] changeImgFilw", e.target.files[0]);

  //     // if (imageProfileRef !== undefined) {
  //     setImgProfileSubtitle(JSON.stringify(e.target.files[0]));
  //     let fileReader = new FileReader();
  //     // fileReader.onload = () => {
  //     //   document.getElementById("imgProfile").src = fileReader.result;
  //     // };
  //     fileReader.onload = (e) => (fileOut.src = e.target.result);
  //     fileReader.readAsDataURL(e.target.files[0]);
  //     console.log(" imgProfileSubtitle changeImgFilw", imgProfileSubtitle);
  //     // fileReader.readAsDataURL(e.target.files[0]);
  //   } else {
  //     toggleLoadingRequesting(false);
  //     toggleWarningRequesting(true, "Carga una imagen.");
  //   }

  //   console.log(
  //     " imgProfileSubtitle changeImgFilw fuer if",
  //     imgProfileSubtitle
  //   );

  //   let body = new FormData();
  //   body.append("companyId", selectedUser.companyId);
  //   body.append("logo", e.target.files[0]);
  //   setDataImgProfile(body);

  //   // handleChangeImgProfile(token, body);
  // };

  // let companyId = selectedUser.companyId;
  //Create certificate client company
  const handleChangeImgProfile = async (token, dataImgProfile) => {
    toggleLoadingRequesting(true);
    try {
      let clientCompanyService = new ClientCompanyService(
        process.env.REACT_APP_MIFIRMA_API
      );
      let res = await clientCompanyService.updateClientCompanyLogo(
        token,
        dataImgProfile
      );
      if (res && res.statusCode === 200) {
        let clientsCompanyInfo = await clientCompanyService.getClientCompany(
          userInformation.clientId,
          token,
          process.env.REACT_APP_ENDPOINT_CLIENT_COMPANY_ORIGIN_COMPANIES
        );
        toggleLoadingRequesting(false);
        moment.locale("es");
        clientsCompanyInfo.data.map((client) => {
          client.clientName = client.company.businessName;
          let dateModification = client.updatedDate.split("T")[0];
          client.lastModificationDate = moment(dateModification)
            .format("DD-MMM-YYYY")
            .replace(/\./g, "");
          client.status = client.company.status;
          client.imgProfile =
            client.company.logo === null
              ? businessIconDefault
              : client.company.logo;
          client.companyName = client.company.companyName;
          client.turnOfTheCompany = client.company.turnOfTheCompany;
          client.typeOfCompany = client.company.typeOfCompany;

          return clientsCompanyInfo.data;
        });

        let companiessToShow = []
        if (pathView === 'entities-administration') {
          let entitites = clientsCompanyInfo.data.filter((company) => company.company.registryType === (process.env.REACT_APP_STATUS_APPLICATION_TYPE_PERSON_ENTITY || process.env.REACT_APP_STATUS_APPLICATION_TYPE_ORGANIZATION_ENTITY))
          companiessToShow = entitites
        } else {
          let companies = clientsCompanyInfo.data.filter((company) => company.company.registryType === process.env.REACT_APP_STATUS_APPLICATION_TYPE_BUSINESS_REASON)
          companiessToShow = companies
        }

        toggleCompletedRequesting(true, " ", companiessToShow);
        // forceRefresh();
        setTimeout(() => {
          hideShowDetails();
        }, 4000);
      } else if (res && res.statusCode === -1) {
        toggleLoadingRequesting(false);
        toggleErrorRequesting(true, " ");
        setTimeout(() => {
          hideShowDetails();
        }, 4000);
      }
    } catch (error) {
      toggleLoadingRequesting(false);
      toggleErrorRequesting(true, " ");

      setTimeout(() => {
        hideShowDetails();
      }, 4000);
      // await hideShowDetails();
      return false;
    }
  };

  //Update status client company
  const saveStatusForCompany = async (token, clientCompanyStatus) => {
    toggleLoadingRequesting(true);
    try {
      let clientCompanyService = new ClientCompanyService(
        process.env.REACT_APP_MIFIRMA_API
      );
      let res = await clientCompanyService.updateClientCompanyStatus(
        token,
        clientCompanyStatus
      );
      if (typeof imageProfile !== "string") {
        let body = new FormData();
        body.append("companyId", res.data.id);
        body.append("logo", imageProfile);
        await clientCompanyService.updateClientCompanyLogo(token, body);
      }
      if (res && res.statusCode === 200) {
        let clientsCompanyInfo = await clientCompanyService.getClientCompany(
          userInformation.clientId,
          token,
          process.env.REACT_APP_ENDPOINT_CLIENT_COMPANY_ORIGIN_COMPANIES
        );
        moment.locale("es");
        clientsCompanyInfo.data.map((client) => {
          client.clientName = client.company.businessName;
          let dateModification = client.updatedDate.split("T")[0];
          client.lastModificationDate = moment(dateModification)
            .format("DD-MMM-YYYY")
            .replace(/\./g, "");
          client.status = client.company.status;
          client.imgProfile =
            client.company.logo === null
              ? businessIconDefault
              : client.company.logo;
          client.companyName = client.company.companyName;
          client.turnOfTheCompany = client.company.turnOfTheCompany;
          client.typeOfCompany = client.company.typeOfCompany;

          return clientsCompanyInfo.data;
        });

        let companiessToShow = []
        if (pathView === 'entities-administration') {
          let entitites = clientsCompanyInfo.data.filter((company) => company.company.registryType === (process.env.REACT_APP_STATUS_APPLICATION_TYPE_PERSON_ENTITY || process.env.REACT_APP_STATUS_APPLICATION_TYPE_ORGANIZATION_ENTITY))
          companiessToShow = entitites
        } else {
          let companies = clientsCompanyInfo.data.filter((company) => company.company.registryType === process.env.REACT_APP_STATUS_APPLICATION_TYPE_BUSINESS_REASON)
          companiessToShow = companies
        }

        toggleLoadingRequesting(false);
        toggleCompletedRequesting(true, " ", companiessToShow);
        setTimeout(() => {
          hideShowDetails();
        }, 4000);
      } else if (res && res.statusCode === -1) {
        toggleLoadingRequesting(false);
        toggleErrorRequesting(true, " ");
        setTimeout(() => {
          hideShowDetails();
        }, 4000);
      }
    } catch (error) {
      toggleLoadingRequesting(false);
      toggleErrorRequesting(true, " ");
      setTimeout(() => {
        hideShowDetails();
      }, 4000);
    }
  };

  //Create client company
  const createCompany = async (token, clientCompanyInformation) => {
    toggleLoadingRequesting(true);
    let clientCompanyService = new ClientCompanyService(
      process.env.REACT_APP_MIFIRMA_API
    );
    try {
      if (clientCompanyInformation && imageProfile) {
        // if (clientCompanyInformation && typeof imageProfile !== "string") {
        let res = await clientCompanyService.createNewClientCompany(
          token,
          clientCompanyInformation
        );
        if (res && res.statusCode === 200) {
          if (typeof imageProfile !== "string") {
            let body = new FormData();
            body.append("companyId", res.data.company.id);
            body.append("logo", imageProfile);
            let updateImg = await clientCompanyService.updateClientCompanyLogo(
              token,
              body
            );
            if (updateImg.statusCode !== 200) {
              toggleWarningRequesting(true, "Agrega una  imagen.");
            }
          }
          let clientsCompanyInfo = await clientCompanyService.getClientCompany(
            userInformation.clientId,
            token,
            process.env.REACT_APP_ENDPOINT_CLIENT_COMPANY_ORIGIN_COMPANIES
          );

          moment.locale("es");
          clientsCompanyInfo.data.map((client) => {
            client.clientName = client.company.businessName;
            let dateModification = client.updatedDate.split("T")[0];
            client.lastModificationDate = moment(dateModification)
              .format("DD-MMM-YYYY")
              .replace(/\./g, "");
            client.status = client.company.status;
            client.imgProfile =
              client.company.logo === null
                ? businessIconDefault
                : client.company.logo;
            client.companyName = client.company.companyName;
            client.turnOfTheCompany = client.company.turnOfTheCompany;
            client.typeOfCompany = client.company.typeOfCompany;

            return clientsCompanyInfo.data;
          });

          let companiessToShow = []
          if (pathView === 'entities-administration') {
            let entitites = clientsCompanyInfo.data.filter((company) => company.company.registryType === (process.env.REACT_APP_STATUS_APPLICATION_TYPE_PERSON_ENTITY || process.env.REACT_APP_STATUS_APPLICATION_TYPE_ORGANIZATION_ENTITY))
            companiessToShow = entitites
          } else {
            let companies = clientsCompanyInfo.data.filter((company) => company.company.registryType === process.env.REACT_APP_STATUS_APPLICATION_TYPE_BUSINESS_REASON)
            companiessToShow = companies
          }

          toggleLoadingRequesting(false);
          toggleCompletedRequesting(true, " ", companiessToShow);
          setTimeout(() => {
            hideShowDetails();
          }, 4000);
        } else if (res) {
          toggleLoadingRequesting(false);
          toggleErrorRequesting(true, res.message);
          // setTimeout(() => {
          //   hideShowDetails();
          // }, 4000);
        }
        // }
      }
      // else {
      //   toggleLoadingRequesting(false);
      //   toggleWarningRequesting(true, "Carga una imagen de perfil.");
      //   setTimeout(() => {
      //     hideShowDetails();
      //   }, 4000);
      // }
    } catch (error) {
      toggleLoadingRequesting(false);
      toggleErrorRequesting(true, " ");
      setTimeout(() => {
        hideShowDetails();
      }, 4000);
    }
  };

  //Update client company
  const updateCompany = async (token, clientCompanyInformation) => {
    toggleLoadingRequesting(true);
    try {
      // if (clientCompanyInformation && typeof imageProfile !== "string") {
      let clientCompanyService = new ClientCompanyService(
        process.env.REACT_APP_MIFIRMA_API
      );
      let res = await clientCompanyService.updateClientCompany(
        token,
        clientCompanyInformation
      );
      if (typeof imageProfile !== "string") {
        let body = new FormData();
        body.append("companyId", res.data.id);
        body.append("logo", imageProfile);
        await clientCompanyService.updateClientCompanyLogo(token, body);
      }
      if (res && res.statusCode === 200) {
        let clientsCompanyInfo = await clientCompanyService.getClientCompany(
          userInformation.clientId,
          token,
          process.env.REACT_APP_ENDPOINT_CLIENT_COMPANY_ORIGIN_COMPANIES
        );
        moment.locale("es");
        clientsCompanyInfo.data.map((client) => {
          client.clientName = client.company.businessName;
          let dateModification = client.updatedDate.split("T")[0];
          client.lastModificationDate = moment(dateModification)
            .format("DD-MMM-YYYY")
            .replace(/\./g, "");
          client.status = client.company.status;
          client.imgProfile =
            client.company.logo === null
              ? businessIconDefault
              : client.company.logo;
          client.companyName = client.company.companyName;
          client.description = client.company.description;
          client.turnOfTheCompany = client.company.turnOfTheCompany;
          client.typeOfCompany = client.company.typeOfCompany;

          return clientsCompanyInfo.data;
        });


        let companiessToShow = []
        if (pathView === 'entities-administration') {
          let entitites = clientsCompanyInfo.data.filter((company) => company.company.registryType === (process.env.REACT_APP_STATUS_APPLICATION_TYPE_PERSON_ENTITY || process.env.REACT_APP_STATUS_APPLICATION_TYPE_ORGANIZATION_ENTITY))
          companiessToShow = entitites
        } else {
          let companies = clientsCompanyInfo.data.filter((company) => company.company.registryType === process.env.REACT_APP_STATUS_APPLICATION_TYPE_BUSINESS_REASON)
          companiessToShow = companies
        }

        toggleLoadingRequesting(false);
        toggleCompletedRequesting(true, " ", companiessToShow);
        setTimeout(() => {
          hideShowDetails();
        }, 4000);
      } else if (res && res.statusCode === -1) {
        toggleLoadingRequesting(false);
        toggleErrorRequesting(true, " ");
      }
    } catch (error) {
      toggleLoadingRequesting(false);
      toggleErrorRequesting(true, " ");
      setTimeout(() => {
        hideShowDetails();
      }, 4000);
    }
  };

  //Create address client company
  const updateAddress = async (token, clientCompanyInformation) => {
    toggleLoadingRequesting(true);
    try {
      // if (clientCompanyInformation && typeof imageProfile !== "string") {
      let clientCompanyService = new ClientCompanyService(
        process.env.REACT_APP_MIFIRMA_API
      );
      let res = await clientCompanyService.updateClientCompanyAddress(
        token,
        clientCompanyInformation
      );
      if (typeof imageProfile !== "string") {
        let body = new FormData();
        body.append("companyId", res.data.id);
        body.append("logo", imageProfile);
        await clientCompanyService.updateClientCompanyLogo(token, body);
      }
      if (res && res.statusCode === 200) {
        let clientsCompanyInfo = await clientCompanyService.getClientCompany(
          userInformation.clientId,
          token,
          process.env.REACT_APP_ENDPOINT_CLIENT_COMPANY_ORIGIN_COMPANIES
        );
        toggleLoadingRequesting(false);
        moment.locale("es");
        clientsCompanyInfo.data.map((client) => {
          client.clientName = client.company.businessName;
          let dateModification = client.updatedDate.split("T")[0];
          client.lastModificationDate = moment(dateModification)
            .format("DD-MMM-YYYY")
            .replace(/\./g, "");
          client.status = client.company.status;
          client.imgProfile =
            client.company.logo === null
              ? businessIconDefault
              : client.company.logo;
          client.companyName = client.company.companyName;
          client.turnOfTheCompany = client.company.turnOfTheCompany;
          client.typeOfCompany = client.company.typeOfCompany;

          return clientsCompanyInfo.data;
        });

        let companiessToShow = []
        if (pathView === 'entities-administration') {
          let entitites = clientsCompanyInfo.data.filter((company) => company.company.registryType === (process.env.REACT_APP_STATUS_APPLICATION_TYPE_PERSON_ENTITY || process.env.REACT_APP_STATUS_APPLICATION_TYPE_ORGANIZATION_ENTITY))
          companiessToShow = entitites
        } else {
          let companies = clientsCompanyInfo.data.filter((company) => company.company.registryType === process.env.REACT_APP_STATUS_APPLICATION_TYPE_BUSINESS_REASON)
          companiessToShow = companies
        }

        toggleCompletedRequesting(true, " ", companiessToShow);
        forceRefresh();
        setTimeout(() => {
          hideShowDetails();
        }, 4000);
      } else if (res && res.statusCode === -1) {
        toggleLoadingRequesting(false);
        toggleErrorRequesting(true, " ");
      } else if (res && res.statusCode === 420) {
        toggleLoadingRequesting(false)
        toggleWarningRequesting(true, "Hay un error en la direccion!")
      }
    } catch (error) {
      toggleLoadingRequesting(false);
      toggleErrorRequesting(true, " ");
      setTimeout(() => {
        hideShowDetails();
      }, 4000);
      return false;
    }
  };

  //Create certificate client company
  const createCertificate = async (
    token,
    clientCompanyCertificate,
    certificateBody
  ) => {
    toggleLoadingRequesting(true);
    try {
      let clientCompanyService = new ClientCompanyService(
        process.env.REACT_APP_MIFIRMA_API
      );
      let validateCertificate =
        await clientCompanyService.updateCompanyCertificateValidate(
          token,
          clientCompanyCertificate
        );
      toggleLoadingRequesting(true);
      if (
        validateCertificate.data?.certificateValid === true &&
        validateCertificate.statusCode === 200
      ) {
        let res = await clientCompanyService.createCompanyCertificate(
          token,
          certificateBody
        );
        toggleLoadingRequesting(true);
        if (typeof imageProfile !== "string") {
          let body = new FormData();
          body.append("companyId", res.data.id);
          body.append("logo", imageProfile);
          await clientCompanyService.updateClientCompanyLogo(token, body);
        }
        if (res && res.statusCode === 200) {
          let clientsCompanyInfo = await clientCompanyService.getClientCompany(
            userInformation.clientId,
            token,
            process.env.REACT_APP_ENDPOINT_CLIENT_COMPANY_ORIGIN_COMPANIES
          );
          toggleLoadingRequesting(false);
          moment.locale("es");
          clientsCompanyInfo.data.map((client) => {
            client.clientName = client.company.businessName;
            let dateModification = client.updatedDate.split("T")[0];
            client.lastModificationDate = moment(dateModification)
              .format("DD-MMM-YYYY")
              .replace(/\./g, "");
            client.status = client.company.status;
            client.imgProfile =
              client.company.logo === null
                ? businessIconDefault
                : client.company.logo;
            client.companyName = client.company.companyName;
            client.turnOfTheCompany = client.company.turnOfTheCompany;
            client.typeOfCompany = client.company.typeOfCompany;

            return clientsCompanyInfo.data;
          });
          toggleCompletedRequesting(true, " ", clientsCompanyInfo.data);
          // forceRefresh();
          setTimeout(() => {
            hideShowDetails();
          }, 4000);
        } else if (res && res.statusCode === -1) {
          toggleLoadingRequesting(false);
          toggleErrorRequesting(true, " ");
        }
        // hideShowDetails();
      } else if (
        validateCertificate.data?.certificateValid === false &&
        validateCertificate.statusCode === 200
      ) {
        toggleLoadingRequesting(false);
        toggleWarningRequesting(true, "El certificado está vencido.");
      } else if (
        validateCertificate.statusCode === -1
      ) {
        toggleLoadingRequesting(false);
        toggleWarningRequesting(true, "El archivo está dañado o no cumple con los estándares de un certificado.");
      } else if (validateCertificate.statusCode === -2) {
        toggleLoadingRequesting(false);
        toggleWarningRequesting(true, "No se pudo extraer la información del certicado por carácteres especiales.");
      } else if (validateCertificate.statusCode === 420) {
        toggleLoadingRequesting(false);
        toggleWarningRequesting(true, "El RFC del certificado no es válido.");
      } else {
        toggleLoadingRequesting(false);
        toggleWarningRequesting(true, "");
      }
    } catch (error) {
      toggleLoadingRequesting(false);
      toggleErrorRequesting(true, "");
      // await hideShowDetails();
      setTimeout(() => {
        hideShowDetails();
      }, 4000);
      return false;
    }
  };

  useEffect(() => {
    setStateNameComponentUser(nameComponentUser);
  }, [nameComponentUser]);

  useEffect(() => {
    renderComponentUser();
  }, [stateNameComponentUser]);

  const renderComponentUser = useCallback(() => {
    switch (stateNameComponentUser) {
      case t("businessAdministrationPanelView.grid.actions.address"):
        return (
          <BusinessAdministrationAddressView
            selectedUser={selectedUser}
            hideShowDetails={hideShowDetails}
            optionsTypeBusiness={optionsTypeBusiness}
            optionsBusinessTurnover={optionsBusinessTurnover}
            setStateNameComponentUser={setStateNameComponentUser}
            setShowDetails={setShowDetails}
            setHeaderTitleinDetail={setHeaderTitleinDetail}
            token={token}
            showLoadingRequesting={showLoadingRequesting}
            showCompletedRequesting={showCompletedRequesting}
            showErrorRequesting={showErrorRequesting}
            showWarningRequesting={showWarningRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleCompletedRequesting={toggleCompletedRequesting}
            toggleWarningRequesting={toggleWarningRequesting}
            toggleErrorRequesting={toggleErrorRequesting}
            showDetailComponent={showDetailComponent}
            toggleShowDetailComponent={toggleShowDetailComponent}
            // onChangeImgProfile={onChangeImgProfile}
            updateAddress={updateAddress}
            handleChangeImgProfile={handleChangeImgProfile}
            imgProfileSubtitle={imgProfileSubtitle}
            setImgProfileSubtitle={setImgProfileSubtitle}
            imageProfile={imageProfile}
            changeImgFile={onChangeImgProfile}
            uploadFileCustom={uploadFileCustom}
            nameComponentUser={nameComponentUser}
            message={message}
          />
        );
      case t("businessAdministrationPanelView.grid.actions.sat"):
        return (
          <BusinessAdministrationCertifiesSATView
            selectedUser={selectedUser}
            hideShowDetails={hideShowDetails}
            token={token}
            createCertificate={createCertificate}
            showDetailComponent={showDetailComponent}
            toggleShowDetailComponent={toggleShowDetailComponent}
            showLoadingRequesting={showLoadingRequesting}
            showCompletedRequesting={showCompletedRequesting}
            showErrorRequesting={showErrorRequesting}
            showWarningRequesting={showWarningRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleCompletedRequesting={toggleCompletedRequesting}
            toggleErrorRequesting={toggleErrorRequesting}
            imgProfileSubtitle={imgProfileSubtitle}
            setImgProfileSubtitle={setImgProfileSubtitle}
            handleChangeImgProfile={handleChangeImgProfile}
            imageProfile={imageProfile}
            changeImgFile={onChangeImgProfile}
            uploadFileCustom={uploadFileCustom}
            setShowDetails={setShowDetails}
            setStateNameComponentUser={setStateNameComponentUser}
            toggleWarningRequesting={toggleWarningRequesting}
            nameComponentUser={nameComponentUser}
            message={message}
          />
        );
      case t("businessAdministrationPanelView.grid.actions.disable"):
        return (
          <BusinessAdministrationDisableView
            selectedUser={selectedUser}
            hideShowDetails={hideShowDetails}
            saveStatusForCompany={saveStatusForCompany}
            token={token}
            // onChangeImgProfile={onChangeImgProfile}
            showDetailComponent={showDetailComponent}
            toggleShowDetailComponent={toggleShowDetailComponent}
            showLoadingRequesting={showLoadingRequesting}
            showCompletedRequesting={showCompletedRequesting}
            showErrorRequesting={showErrorRequesting}
            showWarningRequesting={showWarningRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleCompletedRequesting={toggleCompletedRequesting}
            toggleErrorRequesting={toggleErrorRequesting}
            toggleWarningRequesting={toggleWarningRequesting}
            imgProfileSubtitle={imgProfileSubtitle}
            setImgProfileSubtitle={setImgProfileSubtitle}
            handleChangeImgProfile={handleChangeImgProfile}
            imageProfile={imageProfile}
            changeImgFile={onChangeImgProfile}
            uploadFileCustom={uploadFileCustom}
            setShowDetails={setShowDetails}
            setStateNameComponentUser={setStateNameComponentUser}
            nameComponentUser={nameComponentUser}
            message={message}
          />
        );
      case t("businessAdministrationPanelView.categories"):
        return (
          <BusinessAdministrationCategoriesView
            selectedUser={selectedUser}
            hideShowDetails={hideShowDetails}
            token={token}
            // onChangeImgProfile={onChangeImgProfile}
            toggleCompleted={toggleCompleted}
            showDetailComponent={showDetailComponent}
            toggleShowDetailComponent={toggleShowDetailComponent}
            showLoadingRequesting={showLoadingRequesting}
            showCompletedRequesting={showCompletedRequesting}
            showErrorRequesting={showErrorRequesting}
            showWarningRequesting={showWarningRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleCompletedRequesting={toggleCompletedRequesting}
            toggleErrorRequesting={toggleErrorRequesting}
            toggleWarningRequesting={toggleWarningRequesting}
            imgProfileSubtitle={imgProfileSubtitle}
            setImgProfileSubtitle={setImgProfileSubtitle}
            handleChangeImgProfile={handleChangeImgProfile}
            imageProfile={imageProfile}
            changeImgFile={onChangeImgProfile}
            uploadFileCustom={uploadFileCustom}
            setShowDetails={setShowDetails}
            setStateNameComponentUser={setStateNameComponentUser}
            nameComponentUser={nameComponentUser}
            message={message}
          />
        );
      case t("businessAdministrationPanelView.grid.actions.view.detail"):
        return (
          <BusinessAdministrationDetailView
            selectedUser={selectedUser}
            hideShowDetails={hideShowDetails}
            optionsTypeBusiness={optionsTypeBusiness}
            optionsBusinessTurnover={optionsBusinessTurnover}
            updateCompany={updateCompany}
            createCompany={createCompany}
            token={token}
            validators={validators}
            // onChangeImgProfile={onChangeImgProfile}
            toggleLoadingRequesting={toggleLoadingRequesting}
            showDetailComponent={showDetailComponent}
            toggleShowDetailComponent={toggleShowDetailComponent}
            showLoadingRequesting={showLoadingRequesting}
            showCompletedRequesting={showCompletedRequesting}
            showErrorRequesting={showErrorRequesting}
            showWarningRequesting={showWarningRequesting}
            imgProfileSubtitle={imgProfileSubtitle}
            setImgProfileSubtitle={setImgProfileSubtitle}
            handleChangeImgProfile={handleChangeImgProfile}
            imageProfile={imageProfile}
            changeImgFile={onChangeImgProfile}
            uploadFileCustom={uploadFileCustom}
            toggleCompletedRequesting={toggleCompletedRequesting}
            toggleErrorRequesting={toggleErrorRequesting}
            toggleWarningRequesting={toggleWarningRequesting}
            setShowDetails={setShowDetails}
            setStateNameComponentUser={setStateNameComponentUser}
            nameComponentUser={nameComponentUser}
            message={message}
          />
        );
      case t("businessAdministrationPanelView.addCompany"):
        return (
          <BusinessAdministrationDetailView
            registryTypes={registryTypes}
            selectedUser={selectedUser}
            validators={validators}
            hideShowDetails={hideShowDetails}
            optionsTypeBusiness={optionsTypeBusiness}
            optionsBusinessTurnover={optionsBusinessTurnover}
            createCompany={createCompany}
            updateCompany={updateCompany}
            token={token}
            // onChangeImgProfile={onChangeImgProfile}
            showDetailComponent={showDetailComponent}
            showLoadingRequesting={showLoadingRequesting}
            showCompletedRequesting={showCompletedRequesting}
            showErrorRequesting={showErrorRequesting}
            showWarningRequesting={showWarningRequesting}
            toggleCompletedRequesting={toggleCompletedRequesting}
            toggleErrorRequesting={toggleErrorRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleWarningRequesting={toggleWarningRequesting}
            toggleShowDetailComponent={toggleShowDetailComponent}
            imgProfileSubtitle={imgProfileSubtitle}
            setImgProfileSubtitle={setImgProfileSubtitle}
            handleChangeImgProfile={handleChangeImgProfile}
            imageProfile={imageProfile}
            changeImgFile={onChangeImgProfile}
            uploadFileCustom={uploadFileCustom}
            setStateNameComponentUser={setStateNameComponentUser}
            setShowDetails={setShowDetails}
            nameComponentUser={nameComponentUser}
            message={message}
            setDataImgProfile={setDataImgProfile}
            procedureManager={procedureManager}
            pathView={pathView}
          />
        );
      default:
        return;
    }
  }, [
    stateNameComponentUser,
    setHeaderTitleinDetail,
    selectedUser,
    hideShowDetails,
    token,
    showGettingData,
    validators,
    showDetailComponent,
    showLoadingRequesting,
    showCompletedRequesting,
    showErrorRequesting,
    showWarningRequesting,
    toggleCompletedRequesting,
    toggleLoadingRequesting,
    toggleWarningRequesting,
    toggleErrorRequesting,
  ]);

  return <>{renderComponentUser()}</>;
};

export default BusinessAdministrationConfigurationsView;

